import React, { createContext, useContext, useState, useEffect } from 'react';
import { mockPayments, detailedCaseData, queueStats, unresolvedItems } from '../data/mockData';

const PaymentsContext = createContext();

export const PaymentsProvider = ({ children }) => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate API call - only happens ONCE when app loads
    const fetchPayments = async () => {
      setLoading(true);
      // Simulate network delay
      await new Promise((resolve) => setTimeout(resolve, 500));
      setPayments(mockPayments);
      setLoading(false);
    };

    fetchPayments();
  }, []);

  const getPaymentById = (id) => {
    return payments.find((payment) => payment.id === id);
  };

  const getDetailedPaymentById = (id) => {
    const basicPayment = payments.find((payment) => payment.id === id);
    const detailedData = detailedCaseData[id];

    if (!basicPayment) return null;

    // If detailed data exists, merge it; otherwise return basic payment
    if (detailedData) {
      return {
        id: basicPayment.id,
        priority: basicPayment.priority,
        riskScore: basicPayment.riskScore,
        auditType: basicPayment.auditType,
        region: basicPayment.region,
        recommendation: basicPayment.recommendation,
        flagReasons: basicPayment.flagReasons,
        ...detailedData,
      };
    }

    return basicPayment;
  };

  const getHighPriorityPayments = () => {
    return payments.filter((payment) => payment.priority === 'High' || payment.priority === 'HIGH');
  };

  const getPaymentsByProvider = (providerId) => {
    return payments.filter((payment) => payment.providerId === providerId);
  };

  const value = {
    payments,
    loading,
    queueStats,
    unresolvedItems,
    getPaymentById,
    getDetailedPaymentById,
    getHighPriorityPayments,
    getPaymentsByProvider,
  };

  return (
    <PaymentsContext.Provider value={value}>
      {children}
    </PaymentsContext.Provider>
  );
};

export const usePaymentsContext = () => {
  const context = useContext(PaymentsContext);
  if (!context) {
    throw new Error('usePaymentsContext must be used within PaymentsProvider');
  }
  return context;
};
